(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const getModal = (target) => target.closest('.product-panel')?.querySelector('[data-size-chart-modal]');
  const closeModal = (modal) => {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('size-chart-open');
    modal._opener?.focus();
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-chart-open]');
    if (opener) {
      const modal = getModal(opener);
      if (!modal) return;
      modal._opener = opener;
      modal.hidden = false;
      document.documentElement.classList.add('size-chart-open');
      modal.querySelector('.size-chart-modal__dialog')?.focus();
      return;
    }
    const closer = event.target.closest('[data-size-chart-close]');
    if (closer) closeModal(closer.closest('[data-size-chart-modal]'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-size-chart-modal]').forEach((modal) => {
      if (!modal.hidden) closeModal(modal);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
